module.exports = __webpack_public_path__ + "static/img/djhm.c844a77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/djhm.png
// module id = oYRy
// module chunks = 0